import React, { useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = React.createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('lsb_lang') || 'en');

  const switchLang = (l) => {
    setLang(l);
    localStorage.setItem('lsb_lang', l);
  };

  const t = (path) => {
    const keys = path.split('.');
    let val = translations[lang];
    for (const k of keys) {
      if (val === undefined) return path;
      val = val[k];
    }
    return val !== undefined ? val : path;
  };

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t, translations: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = React.useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be inside LanguageProvider');
  return ctx;
};

export default LanguageContext;
